import { useState } from "react";
import { FileUrl, InfoData, InvestmentBoxData, LogoData } from "../../../../../hooks/useApiCalls";
import { Hardcap, IsClaim, MaximumBuy, MinimumBuy, TokenRatePerEth, TotalSolded, UserBalance } from "../../../../../hooks/useReadPresale";
import SaleCountdown from "./components/SaleCountdown";
import { useAccount } from 'wagmi'
import ConnectButton from "./components/ConnectButton";
import Loading from "../../../../../components/Loading";
import SuccessBox from "./components/SuccessBox";
import { ClaimToken } from "../../../../../hooks/useWritePresale";
import toast from "react-hot-toast";



function IvesmenBox() {

   const { isConnected, address  } = useAccount();
   
 
   const datas = InvestmentBoxData();
   const tokenInfo = datas.token_info ? datas.token_info : {};
   const networkInfo = datas.network ? datas.network : {};
   const tokenRate = TokenRatePerEth();
   
   const totalSoldedETH = TotalSolded() / 1e18;
   const hardcap = Hardcap() / 1e18;
   const minBuy = MinimumBuy() / 1e18;
   const maxBuy = MaximumBuy() / 1e18;

   const [token0,setToken0] = useState();
   const [token1,setToken1] = useState();
   const [loading,setLoading] = useState(false);
   const [buysuccess,setBuysuccess] = useState(false);
   const [tx,setTx] = useState();

   const c = totalSoldedETH / hardcap;
   const progressbarvalue = Math.ceil(c * 100);

   const isClaim = IsClaim();

   const userBal = UserBalance(address)/1e18;
   const PresaleAddr = InfoData();

   
   const calculateToken = (e) =>{
       setToken0(e.target.value)
       const tokenamount = tokenRate * e.target.value;
       setToken1(tokenamount); 
   }

   

   const claim = () =>{
    ClaimToken(PresaleAddr.presalecontract).then((e)=>{

    if(e.status == "success"){
      toast.error("Claim Success");
    }else if(e.status == "error"){
        
        if(e.message.details){
            toast.error(e.message.details);
        }else{
            toast.error(e.message.cause.data.args[0]);
        }                          
    }

    });
   }
 
     return ( 
        <>
     <div className="investment-box">
                <h3 className="stage-title">
                  <span className="online-indicator" /> {tokenInfo.symbol} Presale Live
                </h3>

                <div style={{fontSize: "18px", wordWrap: "break-word", wordBreak: "break-all", textAlign: "center"}} className="stage-title">
                    Presale Contract <br /> 
                    0x52c0Acf7e3B0EBF3603634b081162E99A6696aB6
                  </div>

                           
                  {buysuccess ? <SuccessBox tx = {tx} /> : ""}
                 
                   <hr /><SaleCountdown/>  <hr /> 
                
                <div className="investment-form">
                  <div className="form-group">
                    <label>You send</label>
                    <div className="input-group">
                      <input type="text" className="form-control" onChange={(e)=>{calculateToken(e)}} value={token0} />
                      <div className="input-select">
                      <img src={FileUrl("coin/"+networkInfo.icon)} />
                        {/*}  <i className="fa-brands fa-ethereum" /> {*/}
                        <span>{networkInfo.symbol}</span>
                      </div>
                    </div>
                  </div>
                  <div className="exchange-rate-container">
                    <div className="exchange-rate-left">
                      =
                    </div>
                    <div className="exchange-rate-right">
                      1 {networkInfo.symbol} = {tokenRate} {tokenInfo.symbol}
                    </div>
                  </div>
                  <div className="form-group">
                    <label>You get</label>
                    <div className="input-group">
                      <input type="text" className="form-control" readOnly onChange={(e)=>{setToken1(e.target.value)}} value={token1} />
                      <div className="token-badge">
                        <img src={FileUrl("coin/"+tokenInfo.icon)}  />
                        
                       {/*} <i className="fa-solid fa-coins" /> {*/}
                        <span>{tokenInfo.symbol}</span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-info">
                    <span className="amount">Min Buy: {minBuy} {networkInfo.symbol}</span>
                    <span className="total">Max Buy: {maxBuy} {networkInfo.symbol}</span>
                  </div>
                  <hr />
                  <div className="progress-info">
                    <span className="amount">Solded: {totalSoldedETH} {networkInfo.symbol}</span>
                    <span className="total">HardCap: {hardcap} {networkInfo.symbol}</span>
                  </div>
                  <div className="progress">
                    <div className="progress-bar" role="progressbar" style={{width: progressbarvalue+'%'}}>
                      <span className="percentage-text">{progressbarvalue}%</span>
                    </div>
                  </div>
                   {!isConnected ? <p className="connect-info">CONNECT YOUR WALLET TO BUY {tokenInfo.symbol}</p> : "" } 

                   {loading ? <Loading/> : <ConnectButton isConnected = {isConnected} setLoading = {setLoading} setBuysuccess ={setBuysuccess} setTx = {setTx} amount = {token0} />}

                   {isClaim == "true" && isConnected ? <button data-bs-toggle="modal" data-bs-target="#exampleModal" className="btn btn-connect w-100 mt-3"><i className="fas fa-coins" /> Claim Detail</button> : "" }
                </div>
              </div>

              {isClaim == "true" ? <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" >
                  <div className="modal-content" style={{border:"solid 1px var(--color-card-border-hover)",backgroundColor:"var(--color-card-background)"}}>
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">Claim Detail</h1>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">

                      Balance: <b>{userBal} {tokenInfo.symbol}</b>

                      <br/><br/>

                      <p>
                      The claim will be active when the pre-sale ends.
                      </p>
                    
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button type="button" className="btn btn-primary" onClick={claim}>Claim {tokenInfo.symbol}</button>
                    </div>
                  </div>
                </div>
              </div>  : ""}
      </> 
  ); 

}

export default IvesmenBox;